export enum ApiStoreTemplates{
    
    STORE_TEMPLATE = 'store/admin/store-template/v2/template/',
    STORE_TEMPLATE_BASE = '/template-base',
    STORE_UI_TEMPLATE = 'store/ui/template/',
    ADMIN_STORE = 'store/admin/store-template/',
    ADMIN_TEMPLATE = '/template/',
    SCROLL_TEMPLATE = '/scroll-to/',
    MENUS = 'menus/',
    GO_LIVE = '/publish-to-live',
    THEME = "/theme/",
    SELECT_TEMPLATE = "select-template"

}
